module.exports = __webpack_public_path__ + "static/img/chooseIntro.f00f9bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/chooseIntro.png
// module id = 7NNM
// module chunks = 3